var _templateObject = _taggedTemplateLiteralLoose(['\n  opacity: ', ';\n  transition: all 0.2s ease-in-out;\n  z-index: ', ';\n  pointer-events: ', ';\n  display: block;\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background-color: ', ';\n'], ['\n  opacity: ', ';\n  transition: all 0.2s ease-in-out;\n  z-index: ', ';\n  pointer-events: ', ';\n  display: block;\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background-color: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  box-shadow: 0 5px 10px 0 ', ';\n  background-color: ', ';\n  position: fixed;\n  display: block!important;\n  z-index: ', ';\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 315px;\n  height: 100vh;\n  transform: ', ';\n  transition: transform 0.2s ease-in-out;\n  overflow: scroll;\n  -webkit-overflow-scrolling: touch;\n'], ['\n  box-shadow: 0 5px 10px 0 ', ';\n  background-color: ', ';\n  position: fixed;\n  display: block!important;\n  z-index: ', ';\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 315px;\n  height: 100vh;\n  transform: ', ';\n  transition: transform 0.2s ease-in-out;\n  overflow: scroll;\n  -webkit-overflow-scrolling: touch;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  cursor: pointer;\n  object-fit: contain;\n  svg {\n    width: 16px;\n    height: 16px;\n  }\n'], ['\n  cursor: pointer;\n  object-fit: contain;\n  svg {\n    width: 16px;\n    height: 16px;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  padding: 20px;\n  top: 0;\n  right: 0;\n  color: ', ';\n'], ['\n  position: absolute;\n  padding: 20px;\n  top: 0;\n  right: 0;\n  color: ', ';\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  min-height: 450px;\n'], ['\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  min-height: 450px;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import { gold, primary, primaryWithOpacity, primaryShadow } from '../../assets/colors';
import { zindexModal, zindexModalBackground } from '../../assets/zindex';
import { CancelIcon } from '../Icons';

var Overlay = styled.div(_templateObject, function (props) {
  return props.open && '1' || '0';
}, zindexModalBackground, function (props) {
  return props.open && 'all' || 'none';
}, primaryWithOpacity);

var Side = styled.div(_templateObject2, primaryShadow, primary, zindexModal, function (props) {
  return props.open && 'translateX(0px)' || 'translateX(340px)';
});

var SideClose = styled(CancelIcon)(_templateObject3);

var SideTitle = styled.div(_templateObject4, gold);

var Content = styled.div(_templateObject5);

export default (function (_ref) {
  var open = _ref.open,
      children = _ref.children,
      onClose = _ref.onClose;

  if (open) {
    document.body.classList.add('modal-open');
  } else {
    document.body.classList.remove('modal-open');
  }

  return React.createElement(
    Overlay,
    { open: open, onClick: onClose },
    React.createElement(
      Side,
      { open: open },
      React.createElement(
        Content,
        null,
        React.createElement(
          SideTitle,
          null,
          React.createElement(SideClose, { onClick: onClose })
        ),
        children
      )
    )
  );
});